import type { ColorInputProps } from "./ColorInput";
import { useEffect, useRef, useState } from "react";
import tinycolor from "tinycolor2";
import { setSelectedColor } from "store/features/colorPicker/actions";
import { getSelectedColorInfo } from "client/services/Color/utils/getSelectedColorInfo";
import { useAppDispatch } from "store/store";

export const useColorInput = ({ color, colorFormat, setShowInput, setColorError }: ColorInputProps) => {
    const [value, setValue] = useState(color[colorFormat]);
    const inputRef = useRef<HTMLInputElement>(null);
    const dispatch = useAppDispatch();
    function handleRefLoad() {
        if (!inputRef.current) return;
        inputRef.current.select();
    }
    function onBlur() {
        setShowInput(false);
    }
    function onChange(value: string) {
        setValue(value);
        const color = tinycolor(value);
        if (!color.isValid()) {
            setColorError(getColorErrorText(value));
            return;
        }
        if (colorFormat === "hex" && value.length !== 7 && value.length !== 9) return;
        setColorError(``);
        const { h, s, l } = color.toHsl();
        const colorInputChangeEvent = new CustomEvent("color_input_change", { detail: { h, s, l } });
        document.body.dispatchEvent(colorInputChangeEvent);
        const { r, g, b, a } = color.toRgb();
        dispatch(setSelectedColor(getSelectedColorInfo(r, g, b, a)));
    }
    function getColorErrorText(color: string) {
        return `${color} is not a valid ${colorFormat.toUpperCase()} color.`;
    }
    useEffect(handleRefLoad, [inputRef]);
    useEffect(() => {
        setValue(color[colorFormat]);
    }, [color]);
    return { inputRef, onBlur, value, onChange };
};
